module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAAUVBMVEUAAAA4w083xFE4wlA1w0s4xFAzvEs3xE84xFA4xFA3xFA4xFA4xFA4w1A4xFE4xFA3xE83w1A4xFA5xFE3w08xvEo4xFA3wk42w042wE05xFEvUCzmAAAAGnRSTlMAd3hpIe0PUve7g9nMx7Wsl13y528Y3kI5LDeilu8AAACuSURBVCjPxdLLCsMgEIXhk9QZNXdzz3n/B63uKgTpoqT/YkA+N4MiZoS0yLKkGKTUWJKTyZpIWqNAzUIVXIkdWOzf/MJt9a84CF2NrSf7DY2jhIxnxrRJs97SlIxbkrOuTCdNd9uMr9GPB9B43wDH4Mcr8TOLnb7rLTB13QTYvvNnxnt6e60YW9XFuWcsH3trmkvGtpXlBR1EBsW6SGsfWmysbhu++ExSUkGQgoY3gJYzmofDpfsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/icon-calendar.png
// module id = 104
// module chunks = 0